import React, {Component} from 'react';
import {connect} from 'react-redux';
import {
  Row,
  Col,
  Card,
  CardBody,
  CardText
} from 'reactstrap';
import { Link } from 'react-router-dom';

import {Tbl, TblHead, TblBody} from '../../components/Tbl';
import Paginations from '../../components/Paginations';
import PaginationSummaries from '../../components/Paginations/PaginationSummaries';
import FilterPanel from './Filters';
import FilterContainer from '../../components/Container/FilterContainer/FilterContainer';
import { CardHeaderWithToolbars,Title } from '../../components/Card/CardHeaderWithToolbars';
import Toolbars from './Filters/Toolbars';
import DateToHuman from '../../components/DateToHuman';

import { generateNumber } from '../../utils';
import { DEFAULT_SORT_BY, DEFAULT_PER_PAGE } from '../../constants/settings';
import {getListAccountBank} from '../../actions/accountBankAction';
import privateView from '../../components/hocs/privateView';
import Analytics from "../../services/Analytics";

const dataHeader=[
  'No.','Bank','Branch','Account Name', 'Account Number','Updated At', 'Action'
];

const defaultParams = {
  sort_by : DEFAULT_SORT_BY,
  per_page : DEFAULT_PER_PAGE
}

class AccountBankIndex extends Component{
  constructor(props){
    super(props);        
    this.state={
      _params:{
        ...defaultParams
      },
      _filterOpen: false
    }
    this._handleToggleFilterPanel = this._handleToggleFilterPanel.bind(this);
    this._handleParamsChange = this._handleParamsChange.bind(this);
    this._handleParamsChangeAndSubmit = this._handleParamsChangeAndSubmit.bind(this);
    this._handleGoto = this._handleGoto.bind(this);
    this._handleRefresh = this._handleRefresh.bind(this);
    this._handleResetFilter = this._handleResetFilter.bind(this);
  }
  componentDidMount(){
    this._getList(this.state._params);
    const { email } = this.props.injectedProps;
    Analytics.recordPageView('bank_account_list', email, {
      url: window.location.href,
      location: this.props.location,
      match: this.props.match
    });
  }

  _toggleFilterPanel(){
    this.setState({_filterOpen:!this.state._filterOpen})
  }

  _handleToggleFilterPanel(e){
    e.preventDefault();
    this._toggleFilterPanel();
  }

  _onRenderRowItem(){
    if(this.props.accountBank.list.status_code===200 && this.props.accountBank.list.data.length>0){
      const { current_page,per_page } =  this.props.accountBank.list;
      return this.props.accountBank.list.data.map((item,index)=>
        (
          <tr key={generateNumber(per_page,current_page,index)}>
            <th scope="row">{ generateNumber(per_page,current_page,index) }</th>	
            <td>{ item.bank_name }</td>
            <td>{ item.branch }</td>
            <td>{ item.account_name }</td>
            <td>{ item.account_number }</td>
            <td>{ <DateToHuman value={item.updated_at} id={`tooltip_${generateNumber(per_page,current_page,index)}`}/> }</td>
            <td>
              <Link to={`/bank_accounts/${item.id}`} className="btn btn-link">Details</Link>
            </td>
          </tr>
        )
      )	
    }
    return null;
  }

  _onRenderPagination(){
    const {status_code, data} = this.props.accountBank.list;
    const hasData = (status_code===200&&data.length)||null;
    return hasData && (
      <Paginations 
        size="sm" 
        lastPage={this.props.accountBank.list.last_page} 
        perPage={this.props.accountBank.list.per_page}
        total={this.props.accountBank.list.total}
        maxPage={8}
        path={this.props.accountBank.list.path}
        currentPage={this.props.accountBank.list.current_page} 
        prevPageUrl={this.props.accountBank.list.prev_page_url} 
        nextPageUrl={this.props.accountBank.list.next_page_url} 
        handleGotoCallback={this._handleGoto.bind(this)}
      />
    )
  }

  /**
	 * Handle callback when user click pagination items
	 * @author pewe
	 * @param {integer} page 
	 */
	_handleGoto(page){
    const _params=this.state._params;
    _params.page=page;
    this.setState({_params},()=>this._getList(this.state._params));
  }

  _getList(rawParams = {}){
    let params = {};
    Object.keys(rawParams)
    .filter(key => rawParams[key]!='')
    .forEach(key=> params[key] = rawParams[key]);
    this.props.getList({params});
  }

  _refreshList(){
    const {page, ..._params} = this.state._params;
    this.setState({
      _params
    },()=>this._getList(this.state._params));
  }

  _handleParamsChange(e){
    const { _params } = this.state;
    _params[e.target.name] = e.target.value;
    this.setState({_params});
  }

  _handleParamsChangeAndSubmit(e){
    // Exclude page...
    const { page , ..._params } = this.state._params;
    _params[e.target.name] = e.target.value;
    this.setState({_params},()=>{
      this._getList(this.state._params);
    });
  }

  _handleRefresh(e){
    e.preventDefault();
    this._refreshList();
  }
  
  _handleResetFilter(e){
    e.preventDefault();
    const newState = this.state._filterOpen?{_filterOpen:!this.state._filterOpen}:{};
    this.setState({
      ...newState,
      _params:{
        ...defaultParams
      }
    },()=>this._getList(this.state._params));
  }

  render(){
    return(
      <div className="animated fadeIn">
        <Row>
          <Col xs={12}>
            <Card>
              <CardHeaderWithToolbars>
                <Title>
                  <i className="fa fa-align-justify"></i>
                  <span>Bank Account List</span>
                </Title>
                <Toolbars
                  isOpen={this.state._filterOpen}
                  onToggleFilter={this._handleToggleFilterPanel}
                  onRefreshList={this._handleRefresh}
                  onResetFilter={this._handleResetFilter}                
                />
              </CardHeaderWithToolbars>
              <FilterContainer>
                <FilterPanel 
                  {...this.state._params} 
                  onHandleChange={this._handleParamsChange}
                  onHandleChangeAndSubmit={this._handleParamsChangeAndSubmit}
                  onHandleSearch={this._handleRefresh}
                  isOpen={this.state._filterOpen}
                />
              </FilterContainer>
              <CardBody>
                <CardText>
                  In this section will display our bank accounts.
                </CardText>
                <div className="table-responsive">
                  <PaginationSummaries
                    from={this.props.accountBank.list.from}
                    to={this.props.accountBank.list.to}
                    total={this.props.accountBank.list.total}
                  />
                  <Tbl>
                    <TblHead
                      dataHeader={dataHeader}
                    />
                    <TblBody
                      isLoad={this.props.accountBank.isFetch}
                      hasRow={this.props.accountBank.list.status_code===200&&this.props.accountBank.list.data.length>0}
                      columnCount={dataHeader.length}
                    >
                    { this._onRenderRowItem() }
                    </TblBody>
                  </Tbl>
                </div>
                { this._onRenderPagination() }
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    )
  }
}

const mapStateToProps=({accountBank, auth:{ isFetch, isLogged, roles, id, email }})=>
{
	return {
    accountBank,
    guardData: { isFetch, isLogged, roles, id, email }
	}
}

const mapDispatchToProps=(dispatch)=>
{
	return {
		getList:(filter)=>dispatch(getListAccountBank(filter)),
	}
}

const enhance = connect(mapStateToProps, mapDispatchToProps);
export default enhance(privateView(AccountBankIndex))